
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import InfoIcon from '@/components/icons/InfoIcon.vue';
import storage from '@/services/storage';
import { v4 as uuid } from 'uuid';
import TooltipVariants from '@/entities/TooltipVariants';

import UploadFileIcon from '@/components/icons/UploadFileIcon.vue';
import CrosUpdataFile from '@/components/icons/CrosUpdataFile.vue';
import FileReloadIcon from '@/components/icons/FileReloadIcon.vue';
import ErrorImageIcon from '@/components/icons/ErrorImageIcon.vue';
import PdfFileIcon from '@/components/icons/PdfFileIcon.vue';
import MsWordIcon from '@/components/icons/MsWordIcon.vue';
import splitFileNameExt from '@/utils/splitFileNameExt';
import { NOTIFICATION } from '@/entities/Events';
import Message from '@/data/notificationsMessages';
@Component({
	components: {
		InfoIcon,
		UploadFileIcon,
		CrosUpdataFile,
		ErrorImageIcon,
		MsWordIcon,
		PdfFileIcon,
		FileReloadIcon,
	},
})
export default class FileUpload extends Vue {
	@Prop({ type: Object, default: () => ({}) }) record!: any;
	allowedExtensions = ['pdf', 'doc', 'docx', 'jpg', 'jpeg'];
	fileType: string = '';
	fileName: string = '';
	fileSize: number = 0;
	uploadProgress: number = 0;
	filePreviewUrl: string | null = null;
	TooltipVariants = TooltipVariants;

	async onChange(event: Event) {
		this.uploadProgress = 0;
		const files = (event.target as HTMLInputElement).files;
		const file = files && files.length > 0 ? files[0] : null;
		const extension = file.name.split('.').pop().toLowerCase();
		if (this.allowedExtensions.includes(extension)) {
			if (file) {
				this.fileType = file.name.split('.').pop()?.toLowerCase() || '';
				this.fileName = file.name;
				this.fileSize = file.size;

				this.previewFile(file);
				await this.uploadFile(file);
			}
		} else {
			this.$eventBus.emit(
				NOTIFICATION,
				Message.errorMessage(
					`Only PDF, DOC, DOCX, JPG, and JPEG files are allowed`
				)
			);
		}
	}
	async uploadFile(file: File): Promise<void> {
		try {
			const { ext, name } = splitFileNameExt(file.name);
			const s3Filename = `${name}-${uuid()}.${ext}`;

			const res: any = await storage.save(
				s3Filename,
				file,
				(progress) => {
					this.uploadProgress = progress;
				}
			);
			const key = res?.Key ?? `public/${res.key}`;

			this.$emit('handleFileChange', `${file.name}`, {
				fileType: file.name.split('.').pop()?.toLowerCase(),
				fileName: file.name,
				fileSize: file.size,
				key: key,
			});
		} catch (_) {}
	}
	resetFile() {
		this.fileType = '';
		this.fileName = '';
		this.fileSize = 0;
		this.filePreviewUrl = null;
		(this.$refs.form as any).reset();
		this.$emit('handleFileChange', null);
		this.uploadProgress = 0;
	}

	previewFile(file: File) {
		if (file.type.startsWith('image/')) {
			const reader = new FileReader();
			reader.onload = (e) =>
				(this.filePreviewUrl = e.target?.result as string);
			reader.readAsDataURL(file);
		} else {
			this.filePreviewUrl = null;
		}
	}
	@Watch('record.file')
	fillForm() {
		if (this.record.file) {
			this.uploadProgress = 100;
			this.fileType = this.record.file.fileType;
			this.fileName = this.record.file.fileName;
			this.fileSize = this.record.file.fileSize;
		}
	}

	created() {
		if (this.record.file) {
			this.uploadProgress = 100;
			this.fileType = this.record.file.fileType;
			this.fileName = this.record.file.fileName;
			this.fileSize = this.record.file.fileSize;
		}
	}
	get isPdf() {
		return this.fileType === 'pdf';
	}

	get isDoc() {
		return this.fileType === 'doc' || this.fileType === 'docx';
	}

	get isImage() {
		return this.fileType === 'jpg' || this.fileType === 'jpeg';
	}
}
